<script lang="ts">
	//Svelte
	import { createEventDispatcher } from 'svelte';
	//Services
	import { format } from 'svelte-i18n';
	//Design system components
	import { Button, Container, Modal, Text } from '@Shelly/shelly-design-system';
	import SelectList from 'src/components/SelectList/SelectList.svelte';
	//Types
	import type { Card } from 'src/components/SelectList/SelectList.types';

	export let showModal = false;
	export let title = '';
	export let heading = '';
	export let selectedValue: string = '';
	export let itemsList: Card[] = [];
	export let isLoading = false;

	const dispatchModalClose = createEventDispatcher();
	const dispatchModalSave = createEventDispatcher();

	$: itemsList = setSelectedThermMode(itemsList, selectedValue);

	const setSelectedThermMode = (cardList: Card[], selectedValue: string) => {
		return (cardList || []).map((t: Card) => {
			return {
				...t,
				selected: t.id === selectedValue,
			};
		});
	};

	const onSelectCard = (e: CustomEvent) => {
		selectedValue = e.detail['id'];
	};

	const onClose = () => {
		dispatchModalClose('close');
	};

	const onSave = () => {
		dispatchModalSave('save', { selectedValue });
	};
</script>

<Modal on:close={onClose} {showModal} {title} removeScrollPadding>
	<Container slot="content" noScroll padding="scrollPaddings">
		{#if heading}
			<Text styleType="h2" class="mb-m">{heading}</Text>
		{:else}
			<!-- DO NOT REMOVE COMMENT: Padding references -->
			<div class="pt-s" />
		{/if}

		<SelectList
			on:click
			on:click={onSelectCard}
			showTitleSearchSection={false}
			list={itemsList}
			variant="radio"
		/>

		<!-- DO NOT REMOVE COMMENT: Padding references -->
		<div class="pb-s" />
	</Container>

	<div slot="footer" class="d-flex justify-content-end">
		<Button
			size="l"
			width="full"
			class="width-md-m width-sm-full mr-s"
			variant="secondary"
			responsiveSize={{
				sm: 'm',
			}}
			on:click={onClose}
		>
			{$format('button_cancel', { default: 'Cancel' })}
		</Button>
		<Button
			size="l"
			width="full"
			class="width-md-m width-sm-full"
			responsiveSize={{
				sm: 'm',
			}}
			loading={isLoading}
			on:click={onSave}
		>
			{$format('button_save', { default: 'Save' })}
		</Button>
	</div>
</Modal>
